var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFooterTelegram = function SvgFooterTelegram(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 13,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#footerTelegram_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M12 6.5a6 6 0 1 1-12 0 6 6 0 0 1 12 0M6.215 4.93q-.875.364-3.5 1.507-.425.168-.445.332c-.023.182.206.254.517.352l.131.041c.306.1.719.216.932.22q.292.008.652-.24 2.451-1.654 2.53-1.672c.037-.009.09-.02.125.012.035.031.031.09.027.106-.022.097-.92.93-1.384 1.363-.145.135-.248.23-.269.252l-.14.14c-.286.274-.499.48.01.815.246.162.442.295.638.428.213.146.426.29.702.472q.105.07.203.14c.248.178.472.336.747.311.16-.015.327-.165.41-.615.2-1.063.59-3.365.68-4.313a1 1 0 0 0-.01-.237.25.25 0 0 0-.085-.162.4.4 0 0 0-.233-.07c-.225.004-.572.125-2.238.817"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "footerTelegram_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 .5h12v12H0z"
  })))));
};
export default SvgFooterTelegram;